import BottomSheet from 'components/bottom-sheet';
import Button from 'components/button';
import styles from './styles.module.scss';

interface IModalTradeInProps {
  isOpen: boolean;
  title: string;
  text: string;
  onRedirect: () => void;
  onDismiss: (value: boolean) => void;
}

const ModalRedirectToPageWizard = ({
  isOpen,
  text,
  title,
  onRedirect,
  onDismiss,
}: IModalTradeInProps) => {
  return (
    <BottomSheet
      initialFocusRef={false}
      open={isOpen}
      onDismiss={() => onDismiss(false)}
      snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight - 100]}
    >
      <div className={styles.modalRedirectToPageWizard}>
        <div className={styles.modalRedirectToPageWizard__container}>
          <div className={styles.modalRedirectToPageWizard__title}>{title}</div>
          <div className={styles.modalRedirectToPageWizard__text}>{text}</div>
          <div className={styles.modalRedirectToPageWizard__button}>
            <Button label='Перейти к офрмлению заявки' onClick={onRedirect} />
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};
export default ModalRedirectToPageWizard;
